import React from "react";
import { ArrowRight } from "lucide-react";

interface ModalityCardProps {
  title: string;
  description: string;
  link: string;
  imageUrl: string;
}

const ModalityCard: React.FC<ModalityCardProps> = ({ title, description, link, imageUrl }) => {
  return (
    <a href={link} className="group block h-full">
      <article className="h-full overflow-hidden rounded-md border border-emerald-900/10 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
        <div className="flex h-48 items-center justify-center bg-white p-4">
          <img
            src={imageUrl}
            alt={title}
            className="h-full w-full object-contain"
            loading="lazy"
          />
        </div>
        <div className="flex flex-col justify-between p-5">
          <div>
            <span className="eyebrow bg-emerald-50">Modalidad</span>
            <h3 className="mt-4 text-2xl font-semibold leading-tight text-emerald-950">{title}</h3>
            <p className="mt-3 text-sm leading-6 text-slate-600">{description}</p>
          </div>
          <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[var(--accent)]">
            Ver cursos <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
          </span>
        </div>
      </article>
    </a>
  );
};

export default ModalityCard;
